<script setup>
import {
  BadgeCheck,
  Bell,
  ChevronsUpDown,
  CreditCard,
  LogOut,
  Sparkles,
} from "lucide-vue-next";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';

import { useViewStore } from '@/stores/viewStore'

const viewStore = useViewStore();

import { useUserStore } from '@/stores/userStore';

const userStore = useUserStore();

const props = defineProps({
  user: { type: Object, required: true },
});

const { isMobile } = useSidebar();

</script>

<template>
  <SidebarMenu>
	<SidebarMenuItem>
		<SidebarMenuButton>	
			<LogOut />
			<a href="/logout">Log out {{ viewStore.username }}</a>
			
		</SidebarMenuButton>
	</SidebarMenuItem>
  </SidebarMenu>
</template>
